module.exports = __webpack_public_path__ + "static/media/3dicon.5dc8516a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3dicon.svg
// module id = 1721
// module chunks = 0